import Client from '../client';
import {flattenObject} from '../helpers';

import {
  GetSkusInventoryRequestBuilder,
  GetSkusInventorySumRequestBuilder,
} from '../skus/skus';
const token = localStorage.getItem('token') || '';

class SkusRepository {
  getSkusInventory = async (actions: any) => {
    const {pagination} = actions.payload;
    const makeRequest = new GetSkusInventoryRequestBuilder()
      .params(flattenObject({...pagination, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getSkusInventoryFinalizedSum = async (actions: any) => {
    const {id, pagination} = actions.payload;
    const params = {
      'parcelFinalized.equals': true,
    };
    const makeRequest = new GetSkusInventorySumRequestBuilder()
      .id(id)
      .params(
        flattenObject({
          ...pagination,
          ...params,
          sort: 'id,desc',
        })
      )
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getSkusInventoryNotFinalizedSum = async (actions: any) => {
    const {id, pagination} = actions.payload;
    const params = {
      'parcelFinalized.equals': false,
    };
    const makeRequest = new GetSkusInventorySumRequestBuilder()
      .id(id)
      .params(
        flattenObject({
          ...pagination,
          ...params,
          sort: 'id,desc',
        })
      )
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
  getSkusInventoryWithId = async (actions: any) => {
    const {id, pagination} = actions.payload;
    const makeRequest = new GetSkusInventoryRequestBuilder()
      .id(id)
      .params(flattenObject({...pagination, sort: 'id,desc'}))
      .build();

    const client = new Client(token);
    const response = await client.execute(makeRequest);
    return response;
  };
}
export default new SkusRepository();
